import { useLocale, useTranslations } from 'next-intl';

import Text from '@commons/components/Text';

import type { ArticleNodeProps } from '.';

// Extracting the `date` property and making it required.

type ArticleDateProps = Required<Pick<ArticleNodeProps, 'date'>>;

/**
 * Reusable component to display the date of a blog post.
 */

export const ArticleDate = ({ date }: ArticleDateProps) => {
  const currentLocale = useLocale();

  const dateTime = new Date(date);

  const correctedDate = new Date(dateTime.getTime() + dateTime.getTimezoneOffset() * 60000);
  const formattedDate = `${correctedDate.getDate()} ${correctedDate
    .toLocaleString(currentLocale, { month: 'short' })
    .toUpperCase()} ${correctedDate.getFullYear()}`;

  return (
    <Text level="label-md" color="grey-5" transform="uppercase" marginBottom="none">
      {formattedDate}
    </Text>
  );
};

// Extracting the `readTime` property and making it required.

type ArticleReadTimeProps = Required<Pick<ArticleNodeProps, 'readTime'>>;

/**
 * Reusable component to display the read time of a blog post.
 */

export const ArticleReadTime = ({ readTime }: ArticleReadTimeProps) => {
  const t = useTranslations('readTime');

  return (
    <Text level="label-md" color="grey-5" transform="uppercase" marginBottom="none">
      {t('minutes', { count: readTime.minutes })}
    </Text>
  );
};
